import React from "react";
import PropTypes from "prop-types";

const SmileIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      transform="translate(2 2)"
      stroke="#57595D"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="10" cy="10" r="10" />
      <path d="M6,12 C6,12 7.5,14 10,14 C12.5,14 14,12 14,12" />
      <path d="M7,7 L7.01,7" />
      <path d="M13,7 L13.01,7" />
    </g>
  </svg>
);
SmileIcon.propTypes = {
  className: PropTypes.string
};

export default SmileIcon;
